import React, { Component } from "react";
// import config from "../config.json";
import urls from "../urls.json";
import httpService from "../services/httpService";

const apiDomain = process.env.REACT_APP_API_DOMAIN;
// From .env or .env.development; adjusts to 'development' or 'production'.
// NB: If we build in dev mode and push to git repo,
// string will be hard-coded with values from .env.development

class UserTest extends Component {
  state = {
    user: {},
  };

  async componentDidMount() {
    const loggedInUser = await this.getCurrentUser();
    console.log("user is", loggedInUser);
    this.setState({
      user: loggedInUser,
    });
  }

  async getCurrentUser() {
    // return { username: "marko", main_role_string: "listener" };
    const getCurrentUserEndpoint = apiDomain + urls.getCurrentUser;
    const result = await httpService.get(getCurrentUserEndpoint);
    console.log("Current user", result);
    return result.data;
  }

  renderUsername() {
    const { user } = this.state;
    if (user) return user.username;
    return "Loading";
  }

  render() {
    return (
      <div className="App-header">
        <p>
          {" "}
          Edit code in <code>awe_react/src</code> and save to reload. Right now,
          I also have <code>npm start</code> server running on port 3000. This
          allows me to quickly see edits before running{" "}
          <code>npm run build</code>.
        </p>
        <p>
          NB: We must <code>npm run build</code> so that pre-generated normal
          javascript files are available in the repo for production.{" "}
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Grow on the go, yo!
        </a>
        <h1>This is super great. loggedInUser is {this.renderUsername()}</h1>
      </div>
    );
  }
}

export default UserTest;
